import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { GlobalService } from '../_services/global.service';
import { ConfigPermissionOption } from '../_helpers/config-permission-option';
@Injectable()
export class AuthPermissionGuard implements CanActivate {
    public configPermissionOption = ConfigPermissionOption;
    constructor(private globalService: GlobalService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let permissions = route.data.permission;
        const account = localStorage.getItem('currentSmmAccount') !== undefined &&
        localStorage.getItem('currentSmmAccount') !== 'undefined' ?
          JSON.parse(localStorage.getItem('currentSmmAccount')) : {};
        if (!Array.isArray(permissions)) {
            permissions = [permissions];
        }
        if(account.admin) {
          return true;
        }
        for (let p of permissions) {
            const isAllowed = this.globalService.canPermission(p);
            if (isAllowed) {
                return true;
            }
        }
        this.router.navigate(['/dashboard']);
        return false;
    }
}






// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_guards/auth-permission.guard.ts